import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { surveyUrl } from "../lib/api";

export const QrCard = ({ business }) => {
  const wrap = useRef(null);
  const url = surveyUrl(business.slug);

  const download = () => {
    const canvas = wrap.current.querySelector("canvas");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${business.slug}-survey-qr.png`;
    a.click();
    toast.success("QR code downloaded");
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Survey link copied");
    } catch {
      toast.error("Couldn't copy automatically — select the link and copy it.");
    }
  };

  return (
    <div className="rounded-3xl border border-slate-200/80 bg-white p-6 sm:p-7 shadow-sm" data-testid="dashboard-qr-card">
      <p className="label-caps">Your survey</p>
      <h3 className="mt-1 font-display text-xl font-bold tracking-tight">Scan to leave feedback</h3>
      <div ref={wrap} className="mt-5 mx-auto w-fit rounded-2xl bg-[#EEF1ED] p-4 border border-slate-200" data-testid="dashboard-qr-code-canvas">
        <QRCodeCanvas value={url} size={200} level="M" marginSize={1} fgColor="#1A2B25" bgColor="#FFFFFF" />
      </div>
      <div className="mt-5 rounded-xl bg-slate-50 border border-slate-200 px-3 py-2.5 text-xs font-mono text-[#4B5A54] break-all select-all" data-testid="dashboard-survey-link">
        {url}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2">
        <button onClick={copy} className="btn-secondary justify-center" data-testid="dashboard-copy-link-btn"><Copy className="w-4 h-4" />Copy link</button>
        <button onClick={download} className="btn-primary justify-center" data-testid="dashboard-download-qr-btn"><Download className="w-4 h-4" />Download QR</button>
      </div>
      <a href={`/s/${business.slug}`} target="_blank" rel="noreferrer" data-testid="dashboard-preview-survey-link"
        className="mt-3 flex items-center justify-center gap-1.5 text-sm font-semibold text-[#2F5D4A] hover:underline">
        Preview survey <ExternalLink className="w-3.5 h-3.5" />
      </a>
    </div>
  );
};
